import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-8311567e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex w-full" }
const _hoisted_2 = { class: "__goal-management-student-detail p-10 md-down:px-4" }
const _hoisted_3 = { class: "flex items-center justify-between" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "__breadcrumbs text-sm text-neutral-500 font-semibold flex-nowrap flex items-center" }, " Làm kế hoạch hiện tại ", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  class: "mr-2 text-neutral-400"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M1.5 7.99996L0.719131 7.37526L0.219375 7.99996L0.719131 8.62465L1.5 7.99996ZM7.5 8.99996C8.05228 8.99996 8.5 8.55224 8.5 7.99996C8.5 7.44767 8.05228 6.99996 7.5 6.99996V8.99996ZM3.3858 4.04193L0.719131 7.37526L2.28087 8.62465L4.94754 5.29132L3.3858 4.04193ZM0.719131 8.62465L3.3858 11.958L4.94754 10.7086L2.28087 7.37526L0.719131 8.62465ZM1.5 8.99996H7.5V6.99996H1.5V8.99996Z",
    fill: "currentColor"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M7.78738 13.3439L8.31032 12.4915L7.78738 13.3439ZM6.97976 12.3905L6.05301 12.7662L6.97976 12.3905ZM14.499 12.5015L15.3875 12.9603L14.499 12.5015ZM12.7525 13.981L12.4461 13.0291L12.7525 13.981ZM14.499 3.49854L15.3875 3.0398L14.499 3.49854ZM13.8333 6.81921V9.18087H15.8333V6.81921H13.8333ZM7.83325 5.42133V5.29122H5.83325V5.42133H7.83325ZM9.58524 12.7782C8.62733 12.6186 8.43551 12.5683 8.31032 12.4915L7.26445 14.1962C7.80406 14.5273 8.47961 14.6216 9.25644 14.751L9.58524 12.7782ZM5.83325 10.7107C5.83325 11.4979 5.81518 12.1795 6.05301 12.7662L7.90651 12.0148C7.85132 11.8787 7.83325 11.6814 7.83325 10.7107H5.83325ZM8.31032 12.4915C8.12826 12.3798 7.98675 12.2128 7.90651 12.0148L6.05301 12.7662C6.29374 13.36 6.71828 13.8612 7.26445 14.1962L8.31032 12.4915ZM13.8333 9.18087C13.8333 10.0882 13.8325 10.7099 13.7946 11.1876C13.7573 11.6573 13.6894 11.8898 13.6104 12.0428L15.3875 12.9603C15.6428 12.4658 15.742 11.929 15.7883 11.3458C15.834 10.7705 15.8333 10.0557 15.8333 9.18087H13.8333ZM9.25644 14.751C10.1198 14.8949 10.8251 15.0132 11.4002 15.0628C11.9832 15.113 12.5291 15.1035 13.0589 14.9329L12.4461 13.0291C12.2822 13.0819 12.0416 13.1107 11.5719 13.0702C11.0943 13.029 10.4806 12.9275 9.58524 12.7782L9.25644 14.751ZM13.6104 12.0428C13.3679 12.5125 12.9493 12.8671 12.4461 13.0291L13.0589 14.9329C14.0653 14.609 14.9025 13.8997 15.3875 12.9603L13.6104 12.0428ZM9.58645 3.22163C10.4814 3.07248 11.0948 2.97099 11.5722 2.92986C12.0416 2.88942 12.2822 2.91819 12.4461 2.97096L13.0589 1.06717C12.5292 0.896646 11.9834 0.887021 11.4005 0.937243C10.8256 0.986778 10.1206 1.10503 9.25766 1.24885L9.58645 3.22163ZM15.8333 6.81921C15.8333 5.9444 15.834 5.22954 15.7883 4.65428C15.742 4.07104 15.6428 3.53429 15.3875 3.0398L13.6104 3.95728C13.6894 4.1103 13.7573 4.34283 13.7946 4.81252C13.8325 5.29019 13.8333 5.91191 13.8333 6.81921H15.8333ZM12.4461 2.97096C12.9493 3.13294 13.3679 3.48755 13.6104 3.95728L15.3875 3.0398C14.9025 2.10035 14.0653 1.39113 13.0589 1.06717L12.4461 2.97096ZM9.25766 1.24885C8.83685 1.31898 8.47124 1.37935 8.17099 1.45102C7.85987 1.52528 7.55473 1.62545 7.26252 1.80503L8.30967 3.50898C8.35038 3.48397 8.42887 3.44565 8.63532 3.39637C8.85265 3.3445 9.13857 3.29628 9.58645 3.22163L9.25766 1.24885ZM7.83325 5.29122C7.83325 4.83715 7.83381 4.5472 7.84925 4.3243C7.86391 4.11256 7.88881 4.02884 7.90679 3.98457L6.05387 3.23179C5.92477 3.54955 5.87613 3.86701 5.85403 4.1861C5.8327 4.49405 5.83325 4.86461 5.83325 5.29122H7.83325ZM7.26252 1.80503C6.71792 2.13971 6.29446 2.63958 6.05387 3.23179L7.90679 3.98457C7.98699 3.78717 8.12814 3.62054 8.30967 3.50898L7.26252 1.80503Z",
    fill: "currentColor"
  })
], -1))
const _hoisted_6 = { class: "__goal-management-student-detail__header pt-5" }
const _hoisted_7 = { class: "flex justify-between items-center w-full flex-wrap gap-8" }
const _hoisted_8 = { class: "flex items-center" }
const _hoisted_9 = ["src"]
const _hoisted_10 = { class: "font-medium leading-none text-white text-4xl" }
const _hoisted_11 = { class: "ml-4" }
const _hoisted_12 = { class: "font-bold text-neutral-700 text-4xl md-down:text-2xl" }
const _hoisted_13 = {
  key: 0,
  class: "text-green-500 font-semibold text-xs uppercase"
}
const _hoisted_14 = { class: "flex md-down:w-full justify-start flex-wrap gap-4" }
const _hoisted_15 = { class: "mt-10 w-full md:overflow-x-auto md:scroll-bar--none" }
const _hoisted_16 = { class: "border-b border-neutral-200 md-down:hidden" }
const _hoisted_17 = {
  class: "-mb-px flex space-x-8 tabs",
  "aria-label": "Tabs"
}
const _hoisted_18 = { class: "md:hidden" }
const _hoisted_19 = { class: "p-6 bg-white select-tabs" }
const _hoisted_20 = { class: "flex flex-nowrap items-center" }
const _hoisted_21 = { class: "flex flex-nowrap items-center font-medium" }
const _hoisted_22 = { class: "__goal-management-student-detail__overview p-10 md-down:px-4" }
const _hoisted_23 = {
  class: "h-screen fixed top-0 right-0 overflow-y-auto",
  style: {"width":"inherit","background":"#faf5f1"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Multiselect = _resolveComponent("Multiselect")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_PlanFutureSlideOver = _resolveComponent("PlanFutureSlideOver")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(["flex-1 create-content body-content", { 'body-content--active': _ctx.isSlideOpen }])
    }, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _hoisted_4,
          _createElementVNode("button", {
            type: "button",
            class: "button-p text-center w-fit btn--text text-neutral-500 hover:text-neutral-600",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.back && _ctx.back(...args)))
          }, [
            _hoisted_5,
            _createTextVNode(" Thoát ")
          ])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              (_ctx.student?.profile_photo?.w200)
                ? (_openBlock(), _createElementBlock("img", {
                    key: 0,
                    style: {"min-width":"56px"},
                    class: "shadow-sm inline-block h-14 w-14 rounded-full",
                    src: _ctx.student?.profile_photo?.w200
                  }, null, 8, _hoisted_9))
                : (_openBlock(), _createElementBlock("span", {
                    key: 1,
                    style: _normalizeStyle([{"min-width":"56px"}, {
									background:
										_ctx.student?.profile_photo?.default?.color,
								}]),
                    class: "inline-flex items-center justify-center h-14 w-14 rounded-full"
                  }, [
                    _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.student?.profile_photo?.default?.initial), 1)
                  ], 4)),
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("div", _hoisted_12, _toDisplayString(_ctx.student?.name), 1),
                (_ctx.student?.age)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_13, _toDisplayString(_ctx.student?.age) + " " + _toDisplayString(_ctx.student?.learning_time
											? `| ${_ctx.student?.learning_time}`
											: ''), 1))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("div", null, [
                _createElementVNode("button", {
                  type: "button",
                  class: "button-p text-center btn--ghost",
                  onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.openKHDK && _ctx.openKHDK(...args)))
                }, " Xem trước KHHT ")
              ]),
              _createElementVNode("div", null, [
                _createElementVNode("button", {
                  type: "button",
                  class: "button-p text-center btn--ghost",
                  onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.openMTHT && _ctx.openMTHT(...args)))
                }, " Xem MT hoàn thành ")
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("nav", _hoisted_17, [
                _createVNode(_component_router_link, {
                  to: {
										name: _ctx.routerName.PLANS_REPORT_DETAIL__GOAL_CREATE_CURRENT__CREATE_BY_BANK,
									},
                  class: "border-transparent text-neutral-500 hover:text-yellow-700 hover:border-yellow-500 whitespace-nowrap py-3 px-1 border-b-2 font-semibold"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" Ngân hàng mục tiêu ")
                  ]),
                  _: 1
                }, 8, ["to"]),
                _createVNode(_component_router_link, {
                  to: {
										name: _ctx.routerName.PLANS_REPORT_DETAIL__GOAL_CREATE_CURRENT__CREATE,
									},
                  "data-tour-id": "plan-tab-new",
                  class: "border-transparent text-neutral-500 hover:text-yellow-700 hover:border-yellow-500 whitespace-nowrap py-3 px-1 border-b-2 font-semibold",
                  onClick: _ctx.onSelectNewGoalTab
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" Mục tiêu mới ")
                  ]),
                  _: 1
                }, 8, ["to", "onClick"]),
                _createVNode(_component_router_link, {
                  to: {
										name: _ctx.routerName.PLANS_REPORT_DETAIL__GOAL_STUDENT_LIB__CREATE,
									},
                  class: "border-transparent text-neutral-500 hover:text-yellow-700 hover:border-yellow-500 whitespace-nowrap py-3 px-1 border-b-2 font-semibold"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" Kế hoạch khác ")
                  ]),
                  _: 1
                }, 8, ["to"]),
                _createVNode(_component_router_link, {
                  to: {
										name: _ctx.routerName.PLANS_REPORT_DETAIL__GOAL_CREATE_CURRENT__CREATE_BAY_STOP,
									},
                  class: "border-transparent text-neutral-500 hover:text-yellow-700 hover:border-yellow-500 whitespace-nowrap py-3 px-1 border-b-2 font-semibold"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" Mục tiêu tạm dừng ")
                  ]),
                  _: 1
                }, 8, ["to"]),
                _createVNode(_component_router_link, {
                  to: {
										name: _ctx.routerName.PLANS_REPORT_DETAIL__GOAL_CREATE_CURRENT__CREATE_BY_COMPLETED,
									},
                  class: "border-transparent text-neutral-500 hover:text-yellow-700 hover:border-yellow-500 whitespace-nowrap py-3 px-1 border-b-2 font-semibold"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" Mục tiêu hoàn thành ")
                  ]),
                  _: 1
                }, 8, ["to"])
              ])
            ]),
            _createElementVNode("div", _hoisted_18, [
              _createElementVNode("div", _hoisted_19, [
                _createVNode(_component_Multiselect, {
                  modelValue: _ctx.tab,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.tab) = $event)),
                  "deselect-label": "Đã chọn",
                  "track-by": "value",
                  options: _ctx.tabs,
                  searchable: true,
                  label: "label",
                  "allow-empty": false,
                  selectLabel: "",
                  placeholder: ""
                }, {
                  noResult: _withCtx(() => [
                    _createTextVNode(" Không tìm thấy kết quả ")
                  ]),
                  option: _withCtx((props) => [
                    _createElementVNode("div", _hoisted_20, [
                      _createElementVNode("div", null, _toDisplayString(props.option.label), 1)
                    ])
                  ]),
                  singleLabel: _withCtx(({ option }) => [
                    _createElementVNode("div", _hoisted_21, [
                      _createElementVNode("div", null, _toDisplayString(option.label), 1)
                    ])
                  ]),
                  _: 1
                }, 8, ["modelValue", "options"])
              ])
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_22, [
        _createVNode(_component_router_view, { onUpdated: _ctx.onUpdated }, null, 8, ["onUpdated"])
      ])
    ], 2),
    _createElementVNode("div", {
      class: _normalizeClass(["h-screen create-content slide-content", { 'slide-content--active': _ctx.isSlideOpen }])
    }, [
      _createElementVNode("div", _hoisted_23, [
        _createVNode(_component_PlanFutureSlideOver, {
          onClose: _cache[4] || (_cache[4] = ($event: any) => (_ctx.isSlideOpen = false)),
          onUpdated: _cache[5] || (_cache[5] = ($event: any) => (_ctx.isUpdated = false)),
          "is-completed": _ctx.isCompleted,
          "onUpdate:is-completed": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.isCompleted) = $event)),
          "is-updated": _ctx.isUpdated,
          "onUpdate:is-updated": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.isUpdated) = $event))
        }, null, 8, ["is-completed", "is-updated"])
      ])
    ], 2)
  ]))
}